import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar'
import Header from './components/Header'
import Footer from './components/Footer'
import { Outlet } from 'react-router-dom'




function App() {
  return (
    <div className="App">
          <Header />
          <Navbar />
        <Outlet />
        {/* <HomePage gridItems={GRID_ITEMS}/> */}
        <Footer />
    </div>
  );
}

export default App;
